/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react';
import { Modal, Form, Input, Row, Col, Select, Button, message, Upload, Icon } from 'antd';
import { connect } from 'react-redux';

import { createHomeBlock, editHomeBlock, uploadFile } from '../../../../../../../actions';

class HomeBlockModal extends Component {
  constructor(props) {
    super(props);
    const { initialValue } = props;
    this.state = {
      values: initialValue ? {
        title: initialValue.title || [],
        position: initialValue.position || 1,
        thumbnail: initialValue.thumbnail || 1,
        color: initialValue.color || '#FB5422',
      } : {
        title: [{
          lang: 'vi',
          value: '',
          url: '',
        }],
        position: 1,
        thumbnail: null,
        color: '#FB5422',
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { initialValue } = this.props;
    if (nextProps.initialValue !== initialValue) {
      this.setState({
        values: nextProps.initialValue ? {
          title: nextProps.initialValue.title || [],
          position: nextProps.initialValue.position || 1,
          thumbnail: nextProps.initialValue.thumbnail || 1,
          color: nextProps.initialValue.color || '#FB5422',
        } : {
          title: [{
            lang: 'vi',
            value: '',
            url: '',
          }],
          thumbnail: null,
          position: 1,
          color: '#FB5422',
        },
      });
    }
  }

  beforeUpload = (file) => {
    const { values } = this.state;
    const validImage = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!validImage) {
      message.error('Chỉ được tải lên định dạng JPG hoặc PNG!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Kích thước ảnh phải nhỏ hơn 2MB!');
    }
    if (validImage && isLt2M) {
      this.props.uploadFile({ file, type: 'newImage', key: 'carousel' }, rs => this.setState({
        values: {
          ...values,
          thumbnail: rs.newImage.value,
        },
      }));
    }
    return false;
  }

  handleUpdateField = (field, value) => {
    const { values } = this.state;
    this.setState({
      values: {
        ...values,
        [field]: value,
      },
    });
  }

  handleSubmit = () => {
    const { values } = this.state;
    const { initialValue, createHomeBlock, editHomeBlock, onCancel } = this.props;
    if (!initialValue) {
      createHomeBlock({ data: values,
        response: {
          success: () => {
            this.setState({
              values: {
                title: [{
                  lang: 'vi',
                  value: '',
                  url: '',
                }],
                color: '#FB5422',
                thumbnail: null,
                position: 1,
              },
            });
            onCancel();
          },
          failure: () => {},
        } });
    } else {
      editHomeBlock({ _id: initialValue._id,
        data: values,
        response: {
          success: () => {
            this.setState({
              values: {
                title: [{
                  lang: 'vi',
                  value: '',
                  url: '',
                }],
                thumbnail: null,
                position: 1,
                color: '#FB5422',
              },
            });
            onCancel();
          },
          failure: () => {},
        } });
    }
  }

  render() {
    const { visible, initialValue, onCancel, loading, upload } = this.props;
    const { values } = this.state;
    return (
      <Fragment>
        <Modal
          visible={visible}
          title={initialValue ? 'Cập nhật' : 'Thêm mới'}
          onCancel={onCancel}
          onOk={this.handleSubmit}
          confirmLoading={loading}
          maskClosable={false}
          centered
        >
          <Form.Item label="Tiêu đề">
            {values.title.map((item, index) => (
              <Row key={index} gutter={16} style={{ width: '100%', marginBottom: 10 }}>
                <Col sm={values.title.length > 1 ? 7 : 8}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Ngôn ngữ"
                    value={item.lang}
                    onChange={lang => this.setState({
                      values: {
                        ...values,
                        title: values.title.map((i, idx) => (idx === index ? ({
                          ...i,
                          lang,
                        }) : i)),
                      },
                    })}
                  >
                    <Select.Option value='vi' disabled={values.title.find((i, idx) => i.lang === 'vi' && idx !== index)}>Tiếng Việt</Select.Option>
                    <Select.Option value='en' disabled={values.title.find((i, idx) => i.lang === 'en' && idx !== index)}>Tiếng Anh</Select.Option>
                  </Select>
                </Col>
                <Col sm={8}>
                  <Input
                    style={{ width: '100%' }}
                    placeholder="Giá trị"
                    value={item.value}
                    onChange={e => this.setState({
                      values: {
                        ...values,
                        title: values.title.map((i, idx) => (idx === index ? ({
                          ...i,
                          value: e.target.value,
                        }) : i)),
                      },
                    })}
                  />
                </Col>
                <Col sm={8}>
                  <Input
                    style={{ width: '100%' }}
                    placeholder="Liên kết"
                    value={item.url}
                    onChange={e => this.setState({
                      values: {
                        ...values,
                        title: values.title.map((i, idx) => (idx === index ? ({
                          ...i,
                          url: e.target.value,
                        }) : i)),
                      },
                    })}
                  />
                </Col>
                {values.title.length > 1 && <Col sm={1}>
                  <Button
                    shape="circle" icon="close" onClick={() => this.setState({
                      values: {
                        ...values,
                        title: values.title.filter((_, idx) => idx !== index),
                      },
                    })}
                  />
                </Col>}
              </Row>
            ))}
            {values.title.length < 3 && <Button
              icon="plus" type="dashed" onClick={() => this.setState({
                values: {
                  ...values,
                  title: [...values.title, { lang: '', value: '', url: '' }],
                },
              })}
            >Thêm ngôn ngữ</Button>}
          </Form.Item>
          <Form.Item
            label="Hình ảnh"
          >
            <Upload
              name="thumbnail"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={this.beforeUpload}
            >
              {values.thumbnail
                ? <img style={{ width: 228, height: 128 }} src={values.thumbnail} alt="avatar" />
                : <div>
                  <Icon type={upload.loading ? 'loading' : 'plus'} />
                  <div className="ant-upload-text">Tải lên</div>
                </div>}
            </Upload>
          </Form.Item>
          <Form.Item label="Ưu tiên">
            <Input
              type="number"
              value={values.position}
              onChange={e => this.handleUpdateField('position', e.target.value)}
              placeholder="1"
            />
          </Form.Item>
          <Form.Item label="Màu sắc">
            <Input
              style={{color: values.color || '#FB5422'}}
              value={values.color}
              onChange={e => this.handleUpdateField('color', e.target.value)}
              placeholder="#FB5422"
            />
          </Form.Item>
        </Modal>
      </Fragment>
    );
  }
}

export default connect(state => ({
  upload: state.upload,
}), {
  createHomeBlock,
  editHomeBlock,
  uploadFile,
})(HomeBlockModal);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/HomeBlock/HomeBlockModal.js